<template>
  <div style="background: #F5F7FA;margin-bottom: 20px;margin-top: 10px;">
    <div @mouseenter="showPageBtn" @mouseleave="hidePageBtn" class="box">
        <div class="prepage pagebtn" @click="changePdfPage(0)" v-show="btnFlag">
          <span class="iconfont icon-zuojiantou-01"></span>
        </div>
        <div class="nextpage pagebtn" @click="changePdfPage(1)" v-show="btnFlag">
          <span class="iconfont icon-youjiantou-01"></span>
        </div>

      <div class="pact_left" >
        <div class="pact_title">
          合同预览
          <span v-if="originCurrentPage">{{originCurrentPage}}/{{pageCount}}</span>
        </div>
        <div style="padding:0 30px;margin-top:50px;">
          <Pdf
            :src="targetsrc"
            :page="originCurrentPage"
            @num-pages="pageCount=$event"
            @page-loaded="originCurrentPage=$event"
            @loaded="loadPdfHandlerex"
          ></Pdf>
        </div>
      </div>
    </div>
    <div class="edit-fixed-bottom">
      <el-button @click="onContractDownload" type="primary">合同下载</el-button>
      <el-button @click="onBacktrack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { uploadDown } from '@/util/tool'
import Pdf from 'vue-pdf'
import { queryUploadOcbId } from '@/api/sell/sellManage'
import { queryUploadPcb } from '@/api/purchase/purchaseManage'
export default {
  data () {
    return {
      btnFlag: false,
      targetsrc: '', // 文件路径
      targetCurrentPage: 0, // pdf文件页码
      originCurrentPage: 0,
      fileType: 'pdf', // 文件类型
      // hts: 'http://47.103.134.151:23585',
      url: ''
    }
  },
  components: {
    Pdf
  },
  mounted () {
    this.init()
  },
  methods: {
    showPageBtn () {
      this.btnFlag = true
    },
    hidePageBtn () {
      this.btnFlag = false
    },
    init () {
      if (this.$route.query.id) {
        queryUploadOcbId(this.$route.query.id).then((res) => {
          if (res.data.code === 200) {
            this.url = res.data.obj.fileUrl
            this.targetsrc = Pdf.createLoadingTask(this.$store.state.https + this.url)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
      if (this.$route.query.pcbId) {
        queryUploadPcb(this.$route.query.pcbId).then((res) => {
          if (res.data.code === 200) {
            this.url = res.data.obj.fileUrl
            this.targetsrc = Pdf.createLoadingTask(this.$store.state.https + this.url)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },

    onContractDownload () {
      // 合同下载
      uploadDown(this.$store.state.https + this.url, this.$route.query.pcbNumber)
    },
    onBacktrack () {
      // 返回
      window.history.go(-1)
    },
    loadPdfHandlerex (e) {
      this.originCurrentPage = 1
    },
    changePdfPage (val) {
      if (val === 0 && this.originCurrentPage > 1) {
        this.originCurrentPage--
      }
      if (val === 1 && this.originCurrentPage < this.pageCount) {
        this.originCurrentPage++
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  width: 800px;
  margin: 0 auto 60px;
  height: 750px;
  overflow: hidden;
  position: relative;
}
.iconfont{
  font-size: 28px;
}
.pact_left {
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  overflow: auto;
}

.pact_title {
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  z-index: 99;
  font-size: 18px;
  color: #4e555b;

  span {
    font-size: 14px;
    color: #83878a;
  }
}

.pagebtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 88px;
  background: rgba(39, 108, 255, 0.05);
  cursor: pointer;
  text-align: center;
  line-height: 88px;
  color: #276cff;
  z-index: 99;
  font-weight: bolder;
}

.prepage {
  left: 10px;
  border-radius: 10px 0px 0px 10px;

  span {
    padding: 0;
  }
}

.nextpage {
  right: 20px;
  border-radius: 0px 10px 10px 0px;

  span {
    padding: 0;
  }
}
</style>
